import { render, staticRenderFns } from "./AudioConfig.vue?vue&type=template&id=685343ef&scoped=true&"
import script from "./AudioConfig.vue?vue&type=script&lang=js&"
export * from "./AudioConfig.vue?vue&type=script&lang=js&"
import style0 from "./AudioConfig.vue?vue&type=style&index=0&id=685343ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685343ef",
  null
  
)

export default component.exports